import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const pesoFormatter = new Intl.NumberFormat('en-PH', {
  style: 'currency',
  currency: 'PHP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatPeso(value: number | null | undefined): string {
  return pesoFormatter.format(value ?? 0);
}

export function formatNumber(value: number | null | undefined): string {
  return new Intl.NumberFormat('en-PH').format(value ?? 0);
}

/** Date-only values are UTC-anchored; format in UTC so the calendar day never shifts. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  return dayjs.utc(value).format('DD MMM YYYY');
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return dayjs(value).format('DD MMM YYYY, HH:mm');
}

/** `YYYY-MM-DD` for date inputs and API payloads. */
export function toInputDate(value: string | Date | null | undefined): string {
  if (!value) return '';
  return dayjs.utc(value).format('YYYY-MM-DD');
}

export function todayInput(): string {
  return dayjs().format('YYYY-MM-DD');
}

export function titleCase(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function daysBetween(from: string, to: string = new Date().toISOString()): number {
  return dayjs.utc(to).startOf('day').diff(dayjs.utc(from).startOf('day'), 'day');
}
